module["exports"] = [
  "ԱՄՆ",
  "Ադրբեջան",
  "Ալբանիա",
  "Ալժիր",
  "Ամերիկյան Սամոա",
  "Ամերիկյան Վիրջինյան կղզիներ",
  "Անգիլիա",
  "Անգոլա",
  "Անդորրա",
  "Անտիգուա և Բարբուդա",
  "Ավստրալիա",
  "Ավստրիա",
  "Արգենտինա",
  "Արուբա",
  "Արցախի Հանրապետություն",
  "Արևելյան Թիմոր",
  "Աֆղանստան",
  "Բահամներ",
  "Բահրեյն",
  "Բանգլադեշ",
  "Բարբադոս",
  "Բելառուս",
  "Բելիզ",
  "Բենին",
  "Բերմուդա",
  "Բոլիվիա",
  "Բոսնիա և Հերցեգովինա",
  "Բոտսվանա",
  "Բութան",
  "Բուլղարիա",
  "Բուրկինա Ֆասո",
  "Բուրունդի",
  "Բրազիլիա",
  "Բրիտանական Վիրջինյան Կղզիներ",
  "Բրունեյ",
  "Գաբոն",
  "Գամբիա",
  "Գայանա",
  "Գերմանիա",
  "Գերնսի",
  "Գուամ",
  "Գվատեմալա",
  "Գվինեա",
  "Գվինեա-Բիսաու",
  "Գրենադա",
  "Դանիա",
  "Դոմինիկա",
  "Դոմինիկյան Հանրապետություն",
  "Եգիպտոս",
  "Եթովպիա",
  "Եմեն",
  "Զամբիա",
  "Զիմբաբվե",
  "Էկվադոր",
  "Էստոնիա",
  "Էրիտրեա",
  "Թաիլանդ",
  "Թայվան",
  "Թըրքս և Կայկոս կղզիներ",
  "Թունիս",
  "Թուրքիա",
  "Թուրքմենստան",
  "Ինդոնեզիա",
  "Իռլանդիա",
  "Իսլանդիա",
  "Իսպանիա",
  "Իսրայել",
  "Իտալիա",
  "Իրան",
  "Իրաք",
  "Լաոս",
  "Լատվիա",
  "Լեհաստան",
  "Լեսոթո",
  "Լիբանան",
  "Լիբերիա",
  "Լիբիա",
  "Լիխտենշտայն",
  "Լիտվա",
  "Լյուքսեմբուրգ",
  "Խորվաթիա",
  "Կաբո Վերդե",
  "Կամբոջա",
  "Կամերուն",
  "Կայմանյան կղզիներ",
  "Կանադա",
  "Կատար",
  "Կենտրոնաաֆրիկյան Հանրապետություն",
  "Կիպրոս",
  "Կիրիբատի",
  "Կոլումբիա",
  "Կոմորներ",
  "Կոնգոյի Հանրապետություն",
  "ԿոնգոյիԴեմոկրատական Հանրապետություն ԿԴՀ",
  "Կոստա Ռիկա",
  "Կոտ դ'Իվուար",
  "Կուբա",
  "Կուկի կղզիներ",
  "Հայաստան",
  "Հայիթի",
  "Հասարակածային Գվինեա",
  "Հարավային Կորեա",
  "Հարավաֆրիկյան Հանրապետություն",
  "Հյուսիսային Կորեա",
  "Հյուսիսային Մակեդոնիա",
  "Հյուսիսային Մարիանյան կղզիներ",
  "Հնդկաստան",
  "Հոնդուրաս",
  "Հոնկոնգ",
  "Հորդանան",
  "Հունաստան",
  "Հունգարիա",
  "Ղազախստան",
  "Ղրղզստան",
  "Ճամայկա",
  "Ճապոնիա",
  "ՄԱԷ",
  "ՄԹ",
  "Մադագասկար",
  "Մալայզիա",
  "Մալավի",
  "Մալդիվներ",
  "Մալթա",
  "Մալի",
  "Մակաու",
  "Մայոտ",
  "Մավրիկիոս",
  "Մավրիտանիա",
  "Մարշալյան կղզիներ",
  "Մարոկկո",
  "Մեն կղզի",
  "Մեքսիկա",
  "Միկրոնեզիա",
  "Մյանմա",
  "Մոզամբիկ",
  "Մոլդովա",
  "Մոնակո",
  "Մոնղոլիա",
  "Մոնտսերատ",
  "Նամիբիա",
  "Նաուրու",
  "Նեպալ",
  "Նիգեր",
  "Նիգերիա",
  "Նիդերլանդյան Անտիլներ",
  "Նիդերլանդներ",
  "Նիկարագուա",
  "Նիուե",
  "Նոր Զելանդիա",
  "Նոր Կալեդոնիա",
  "Նորվեգիա",
  "Նորֆոլք կղզի",
  "Շվեդիա",
  "Շվեյցարիա",
  "Շրի Լանկա",
  "Ուգանդա",
  "Ուզբեկստան",
  "Ուկրաինա",
  "Ուոլիս և Ֆուտունա",
  "Ուրուգվայ",
  "Չադ",
  "Չեխիա",
  "Չեռնոգորիա",
  "Չիլի",
  "Չինաստան",
  "Պալաու",
  "Պակիստան",
  "Պաղեստին",
  "Պանամա",
  "Պապուա Նոր Գվինեա",
  "Պարագվայ",
  "Պերու",
  "Պորտուգալիա",
  "Պուերտո Ռիկո",
  "Ջերսի",
  "Ջիբութի",
  "Ջիբրալթար",
  "Ռուանդա",
  "Ռումինիա",
  "Ռուսաստան",
  "Սալվադոր",
  "Սահրավիա",
  "Սամոա",
  "Սան Մարինո",
  "Սան Տոմե և Պրինսիպի",
  "Սաուդյան Արաբիա",
  "Սեյշելներ",
  "Սեն Մարտեն (Ֆրանսիական Անտիլներ)",
  "Սենեգալ",
  "Սենտ Լյուսիա",
  "Սենտ Կիտս և Նևիս",
  "Սենտ Պիեռ և Միկելոն",
  "Սենտ Վինսենտ և Գրենադիներ",
  "Սերբիա",
  "Սիեռա Լեոնե",
  "Սինգապուր",
  "Սիրիա",
  "Սլովակիա",
  "Սլովենիա",
  "Սողոմոնյան Կղզիներ",
  "Սոմալիա",
  "Սուդան",
  "Սուրբ Բարդուղիմեոսի կղզի",
  "Սուրբ Հեղինեի կղզի",
  "Սուրինամ",
  "Սվազիլենդ",
  "Վանուատու",
  "Վատիկան",
  "Վենեսուելա",
  "Վիետնամ",
  "Վրաստան",
  "Տանզանիա",
  "Տաջիկստան",
  "Տոգո",
  "Տոկելաու",
  "Տոնգա",
  "Տուվալու",
  "Տրինիդադ Տոբագո",
  "Փիթքերն կղզիներ",
  "Քենիա",
  "Քուվեյթ",
  "Օման",
  "Ֆարերյան կղզիներ",
  "Ֆիլիպիններ",
  "Ֆինլանդիա",
  "Ֆիջի",
  "Ֆոլկլենդյան կղզիներ",
  "Ֆրանսիա",
  "Ֆրանսիական Պոլինեզիա"
];


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/hy/address/country.js
// module id = 3047
// module chunks = 1610